import { getFormOptions, getOfferOptions, getAllocationOptions, getPublisherOptions, genderOptions, booleanOptions, stateOptions, getCountryOptions } from 'components/rules/options';

const optionalize = fn => () => fn().then(options => ({ options }))

export default {
  incommingTraffic: [
    { name: 'publisherId', label: 'Publisher', type: 'select', loadOptions: optionalize(getPublisherOptions), size: 2 },
    { name: 'allocationId', label: 'Allocation', type: 'select', loadOptions: optionalize(getAllocationOptions), size: 2 },
    { name: 'formId', label: 'Form', type: 'select', loadOptions: optionalize(getFormOptions), size: 2 },
    { name: 'offerId', label: 'Offer', type: 'select', loadOptions: optionalize(getOfferOptions), size: 2 },
    { name: 'partner_id', label: 'Publisher (text)', type: 'input', size: 2 },
    { name: 'sid1', label: 'SID 1', type: 'input', size: 2 },
    { name: 'sid2', label: 'SID 2', type: 'input', size: 2 },
    { name: 'sid3', label: 'SID 3', type: 'input', size: 2 }
  ],
  session: [
    { name: 'duplicated', label: 'Duplicate', type: 'select', options: booleanOptions, size: 2 },
    { name: 'optout', label: 'Opt-out', type: 'select', options: booleanOptions, size: 2 },
    { name: 'fraudVerification', label: 'Fraud', type: 'select', options: booleanOptions, size: 2 },
    { name: 'skipRegistration', label: 'Registration Skipped', type: 'select', options: booleanOptions, size: 2 },
    { name: 'emailVerification', label: 'Is Email Valid', type: 'select', options: booleanOptions, size: 2 },
    { name: 'postalVerification', label: 'Is Postal Valid', type: 'select', options: booleanOptions, size: 2 },
    { name: 'botVerification', label: 'Is Bot', type: 'select', options: booleanOptions, size: 2 },
    { name: 'tcpaconsent', label: 'Is TCPA Consent', type: 'select', options: booleanOptions, size: 2 },
    { name: 'registration_consent', label: 'Is Registration Consent', type: 'select', options: booleanOptions, size: 2 },
    { name: 'recording_consent', label: 'Is Recording Consent', type: 'select', options: booleanOptions, size: 2 },
    { name: 'registrationCompleted', label: 'Is Registration Completed', type: 'select', options: booleanOptions, size: 2 },
    { name: 'trustedformCert', label: 'Trusted Form Cert', type: 'input', size: 2 },
    { name: 'leadidCert', label: 'Lead Id Cert', type: 'input', size: 2 },
  ],
  context: [
    { name: 'dateOfRequest', label: 'Date of Request', type: 'dateTime', size: 2 },
    { name: 'mobile', label: 'Mobile', type: 'select', options: booleanOptions, size: 2 },
  ],
  consumerData: [
    { name: 'firstName', label: 'First Name', type: 'input', size: 2 },
    { name: 'lastName', label: 'Last Name', type: 'input', size: 2 },
    { name: 'email', label: 'Email', type: 'input', size: 3 },
    { name: 'address1', label: 'Address 1', type: 'input', size: 3 },
    { name: 'address2', label: 'Address 2', type: 'input', size: 3 },
    { name: 'city', label: 'City', type: 'input', size: 3 },
    { name: 'state', label: 'State', type: 'select', options: stateOptions, size: 2 },
    { name: 'zip', label: 'Zip', type: 'input', size: 2 },
    { name: 'phone', label: 'Phone', type: 'input', size: 2 },
    { name: 'country', label: 'Country', type: 'select', options: getCountryOptions(), size: 2 },
    { name: 'dob', label: 'Date of birth', type: 'dateTime', size: 2, mask: 'MM/DD/YYYY' },
    { name: 'gender', label: 'Gender', type: 'select', options: genderOptions, size: 2 },
    { name: 'optout', label: 'Opt-out', type: 'select', options: booleanOptions, size: 2 },
    { name: 'unsubscribed', label: 'Unsubscribed', type: 'select', options: booleanOptions, size: 2 },
    { name: 'duplicated', label: 'Duplicate', type: 'select', options: booleanOptions, size: 2 },
  ],
}
